/**
 * @file  接入示例
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-10-25 Baidu
 */

 /* eslint-disable */
export const requestDemo = () => {
    return {
        curl: {
            create:`curl -X POST 'https://dwz.cn/api/v3/short-urls'
     -H 'Content-Type:application/json; charset=UTF-8'
     -H 'Dwz-Token: 你的token'
     -d '[{"LongUrl":"你的长网址1","TermOfValidity":"有效期"},{"LongUrl":"你的长网址2","TermOfValidity":"有效期"}]'`,
            query:`curl -X GET 'https://dwz.cn/api/v3/short-urls/de3rp2Fl' -H 'Dwz-Token: 你的token'`,
            delete:`curl -X DELETE 'https://dwz.cn/api/v3/short-urls/de3rp2Fl' -H 'Dwz-Token: 你的token'`,
            change: `curl -X PATCH 'https://dwz.cn/api/v3/short-urls/7RubjLdH'
    -H 'Content-Type:application/json; charset=UTF-8'
    -H 'Dwz-Token: 你的token'
    -d '{"LongUrl":"你的长网址1"}'`
        },
        python: "https://github.com/zhugelianglongming/dwz-python"
    };
};
/* eslint-enable */
